const getPrimaryNavigationHeight = () => {
  const primaryNavigation = document.querySelector<HTMLElement>(
    '.navigation--primary'
  );
  return primaryNavigation ? primaryNavigation.offsetHeight : 0;
};

export default getPrimaryNavigationHeight;
